var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from "react";
import { BaseInput } from "../components/form/BaseInput";
import { Checkbox } from "../components/form/Checkbox";
import { Combobox } from "../components/form/Combobox";
import { Datepicker } from "../components/form/Datepicker";
import { Fileselect } from "../components/form/Fileselect";
import { Input } from "../components/form/Input";
import { Radio } from "../components/form/Radio";
import { Timepicker } from "../components/form/Timepicker";
import { Button } from "../components/layout/Button";
import { Formable } from "../decorators/Formable";
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mapChildren = function (children) {
            if (children === void 0) { children = _this.props.children; }
            return React.Children.map(children, function (Component) {
                var cProps = Component === null || Component === void 0 ? void 0 : Component.props;
                if (Component && Component.type && [FormInternalInput].some(function (C) { return C.isPrototypeOf(Component.type); })) {
                    var onChange_1 = cProps.onChange, controlName_1 = cProps.controlName, control = _this.props.frm.getOriginal()[controlName_1], value = _this.props.frm.get(controlName_1);
                    return React.cloneElement(Component, __assign(__assign({}, cProps), { onChange: function (val) {
                            _this.props.frm.set(controlName_1, val);
                            if (onChange_1)
                                onChange_1(val);
                        }, value: value, defaultValue: value, checked: control.value, required: control.required, name: controlName_1, disabled: _this.props.frm.isDisabled() || _this.props.frm.isDisabled(controlName_1) || cProps.disabled }));
                }
                else if (Component && Component.type && Component.type === FormButton) {
                    return React.cloneElement(Component, __assign(__assign({}, cProps), { disabled: cProps.disabled || _this.props.frm.isDisabled() }));
                }
                else if (Component && Component.props && cProps.children) {
                    return React.cloneElement(Component, __assign(__assign({}, cProps), { children: _this.mapChildren(cProps.children) }));
                }
                return Component;
            });
        };
        _this.submit = function (e) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            var _a = _this.props, frm = _a.frm, onSubmit = _a.onSubmit;
            var controls = Object.keys(frm.getObjectValue());
            var formValid = true;
            controls.forEach(function (key) {
                var control = frm.get(key), obj = frm.getOriginal()[key];
                if (!Form.validateControl(__assign(__assign({}, obj), { value: control }), frm))
                    formValid = false;
            });
            if (formValid && onSubmit)
                onSubmit(e);
        };
        _this.render = function () {
            var _a = _this.props, className = _a.className, style = _a.style;
            return React.createElement("form", {
                onSubmit: _this.submit,
                className: className,
                style: style,
                children: _this.mapChildren()
            });
        };
        return _this;
    }
    /** Function that checks if the control is valid
     * -In case of string value, it check if the string is not empty (trimmed)
     * -In case of array or FileList, it checks if the length is not 0
     * -In case of boolean value, it checks if the value is true
     * -Otherwise, it checks if the value is not null
     * Note: it also calls the control validator, if it exists. The checks above are done only if the control is required.
     */
    Form.validateControl = function (ctrl, frm) {
        var valid = true;
        var value = ctrl.value;
        if (ctrl.required) {
            if (typeof value === "string" && (value === null || value === void 0 ? void 0 : value.trim()) === "")
                valid = false;
            else if (typeof value === "boolean" && !value)
                valid = false;
            else if ((Array.isArray(value) || value instanceof FileList) && value.length === 0)
                valid = false;
            else
                valid = value != null;
        }
        if (ctrl.validator && !ctrl.validator(value, frm.getObjectValue()))
            valid = false;
        return valid;
    };
    return Form;
}(React.Component));
export { Form };
var FormButton = /** @class */ (function (_super) {
    __extends(FormButton, _super);
    function FormButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () { return React.createElement(Button, __assign(__assign({}, _this.props), { type: "submit" })); };
        return _this;
    }
    return FormButton;
}(React.Component));
export { FormButton };
var FormInternalInput = /** @class */ (function (_super) {
    __extends(FormInternalInput, _super);
    function FormInternalInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormInternalInput;
}(BaseInput));
export { FormInternalInput };
var FormInput = /** @class */ (function (_super) {
    __extends(FormInput, _super);
    function FormInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormInput = __decorate([
        Formable(Input)
    ], FormInput);
    return FormInput;
}(FormInternalInput));
export { FormInput };
var FormCheckbox = /** @class */ (function (_super) {
    __extends(FormCheckbox, _super);
    function FormCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormCheckbox = __decorate([
        Formable(Checkbox)
    ], FormCheckbox);
    return FormCheckbox;
}(FormInternalInput));
export { FormCheckbox };
var FormRadio = /** @class */ (function (_super) {
    __extends(FormRadio, _super);
    function FormRadio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormRadio = __decorate([
        Formable(Radio)
    ], FormRadio);
    return FormRadio;
}(FormInternalInput));
export { FormRadio };
var FormDatepicker = /** @class */ (function (_super) {
    __extends(FormDatepicker, _super);
    function FormDatepicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormDatepicker = __decorate([
        Formable(Datepicker)
    ], FormDatepicker);
    return FormDatepicker;
}(FormInternalInput));
export { FormDatepicker };
var FormTimepicker = /** @class */ (function (_super) {
    __extends(FormTimepicker, _super);
    function FormTimepicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormTimepicker = __decorate([
        Formable(Timepicker)
    ], FormTimepicker);
    return FormTimepicker;
}(FormInternalInput));
export { FormTimepicker };
var FormFileselect = /** @class */ (function (_super) {
    __extends(FormFileselect, _super);
    function FormFileselect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormFileselect = __decorate([
        Formable(Fileselect)
    ], FormFileselect);
    return FormFileselect;
}(FormInternalInput));
export { FormFileselect };
var FormCombobox = /** @class */ (function (_super) {
    __extends(FormCombobox, _super);
    function FormCombobox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormCombobox = __decorate([
        Formable(Combobox)
    ], FormCombobox);
    return FormCombobox;
}(FormInternalInput));
export { FormCombobox };
